"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const actionCreators = __importStar(require("./actions"));
const types_1 = require("../../../loading/types");
const types_2 = require("../../../common/types");
const initialState = {
    isLoading: types_1.LOADING_STATE.LOADING,
    data: null,
    isSaved: types_1.LOADING_STATE.LOADING,
    isDeleted: types_1.LOADING_STATE.LOADING,
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    var _a;
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.requestRecommendedFasteners): {
            draft.isLoading = types_1.LOADING_STATE.LOADING;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestRecommendedFastenersSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            draft.data = action.payload;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestRecommendedFastenersFail): {
            Object.assign(draft, initialState);
            draft.isLoading = types_1.LOADING_STATE.FAILED;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateSelectedRecommendedFastener): {
            const { fastener, connectionType, combineFasteners, selected } = action.payload;
            (_a = draft.data) === null || _a === void 0 ? void 0 : _a.fasteners.forEach((group) => {
                const selectedFastener = group.items.some((item) => item.id === fastener.id && item.quantity === fastener.quantity);
                group.items.forEach((item) => {
                    if (!combineFasteners && (selectedFastener || connectionType !== types_2.CONNECTION_TYPE.COMPONENT)) {
                        item.selected = false;
                    }
                    if (item.id === fastener.id && item.quantity === fastener.quantity) {
                        if (combineFasteners) {
                            item.selected = selected;
                        }
                        else {
                            item.selected = true;
                        }
                    }
                });
            });
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestUpdateItemProject): {
            draft.isSaved = types_1.LOADING_STATE.LOADING;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestUpdateItemProjectSuccess): {
            draft.isSaved = types_1.LOADING_STATE.COMPLETE;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestUpdateItemProjectFail): {
            draft.isSaved = types_1.LOADING_STATE.FAILED;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestDeleteItemProject): {
            draft.isDeleted = types_1.LOADING_STATE.LOADING;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestDeleteItemProjectSuccess): {
            draft.isDeleted = types_1.LOADING_STATE.COMPLETE;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestDeleteItemProjectFail): {
            draft.isDeleted = types_1.LOADING_STATE.FAILED;
            break;
        }
        default:
            break;
    }
});
exports.default = reducer;
